// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3XPGi","Primary":"Button_Primary__1v46q","Disabled":"Button_Disabled__3nwnW","Loading":"Button_Loading__g48ck","swipe":"Button_swipe__1TfS3"};